<template>
  <div class="topic-row" :class="{onScreen, scrollTransition}" v-observe-visibility="scrollTrigger">
    <div :class="alignLeftOrRight">
      <div class="host-head" v-if="host === 'Griffin' && !small_wonder">
        <img src="@/assets/griffin-head.png" />
      </div>
      <div class="host-head" v-if="host === 'Griffin' && small_wonder">
        <img class="left-henry henry" v-if="micro" src="@/assets/micro.png" />
        <img class="left-henry henry" v-else src="@/assets/henry-head.png" />

      </div>
      <div class="bubble" :class="hostBubble">
        <h3 class="name" :class="{propercase: shouldICapitalise}">
          <a v-if="topic_url" target="_blank" :href="topic_url">
            <span v-html="name"></span>
            <i class="material-icons">link</i>
          </a>
          <span v-else>{{name}}</span>
    </h3>
        <p class="topic-name"><a target="_blank" :href="ep_url">{{ep_title}}</a></p>
      </div>
      <div class="host-head" v-if="host === 'Rachel' && !small_wonder">
        <img src="@/assets/rachel-head.png" />
      </div>
      <div class="host-head" v-if="host === 'Rachel' && small_wonder">
        <img class="right-henry henry" v-if="micro" src="@/assets/micro.png" />
        <img class="right-henry henry" v-else src="@/assets/henry-head.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WonderfulTopic',
  data() {
    return {
      onScreen: false
    }
  },
  mounted() {
    if (this.index < 8) {
      this.onScreen = true;
    }
  },
  computed: {
    shouldICapitalise() {
      const addressPattern = /\b\w{1,63}\.\w{1,63}/i;
      return addressPattern.test(this.name) ? false : true
    },
    hostBubble() {
      return {
        griffin: this.host === "Griffin",
        rachel: this.host === "Rachel"
      }
    },
    alignLeftOrRight() {
      return {
        left: this.host === "Griffin",
        right: this.host === "Rachel"
      }
    },
    epTitle() {
      return this.ep_title.replace('Wonderful! ', '');
    }
  },
  methods: {
    scrollTrigger(e) {
      if (!this.onScreen && e) {
        this.onScreen = e;
      }
    }
  },
  props: {
    ep_num: Number,
    scrollTransition: Boolean,
    ep_title: {
      type: String,
      default: "Wonderful! An enthusiast podcast"
    },
    host: {
      validator: (value) => {
        return ['Griffin', 'Rachel'].indexOf(value) !== -1
      },
      required: true
    },
    index: Number,
    name: {
      type: String,
      required: true,
      default: "This awesome website."
    },
    topic_url: {
      type: String
    },
    small_wonder: {
      type: Boolean,
      default: false
    },
    ep_url: {
      type: String,
      default: "http://www.maximumfun.org/shows/wonderful"
    },
    spoiler_mode: {
      type: Boolean,
      default: true
    },
    small_wonder_mode: {
      type: Boolean,
      default: true
    },
    most_recent_ep: {
      type: Number,
      default: 0
    },
    micro: {
      type: Boolean,
      default: false
    }
  }
}

</script>
<style lang="scss" scoped>
$f_size: 1em;
$tgl_width: 32px;
$tgl_height: $tgl_width / 2.5;
$primary: #15A2FE;
$primary_light: #6dd3ff;
$grey: #bbb;
$rach_colour: rgb(254, 225, 133);
$grif_colour: rgb(252, 132, 120);
$break-small: 500px;


h3 {
  font-size: $tgl_width;
  margin: 0;
  display: block;
  padding: 8px 0 0 0;
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.2px;
  @media screen and (max-width: $break-small) {
    font-size: 5vw;
    line-height: 1;
  }

  i {
    font-size: 80%;
    transform: translateY(8%);

    @media screen and (max-width: $break-small) {
      transform: translateY(5%);
    }
  } // i {
  //   line-height: 1.3em;
  //   display: inline;
  //   vertical-align: bottom;
  //   @media screen and (max-width: $break-small) {
  //     line-height: .85em;
  //     font-size: 1em;
  //   }
  // }
  a {
    color: inherit;
    text-decoration: none;
    border: 0;
  }
}

p {
  margin: ($tgl_width/8) 0 0 0;
  padding: 4px 0;
  font-style: italic;
  a {
    color: inherit;
    text-decoration: none;
    line-height: 1.5;
  }

  @media screen and (max-width: $break-small) {
    font-size: 16px;
  }
}

.propercase {
  text-transform: capitalize;
}

h3 {
  display: inline;
  a:hover {
    color: black;
  }
}


.griffin {
  background-color: $grif_colour;
  color: #562D29;
  padding: 20px 40px 10px 25px;
  border-radius: ($tgl_width * 2) ($tgl_width * 2) ($tgl_width * 2) 10px;

  .topic-name {
    a:hover {
      border-bottom: 2px solid #574305;
    }
  }
}

.rachel {
  background-color: $rach_colour;
  color: #574305;
  padding: 20px 25px 10px 40px;
  border-radius: ($tgl_width * 2) ($tgl_width * 2) 10px ($tgl_width * 2);



  .topic-name {
    a:hover {
      border-bottom: 2px solid #574305;
    }
  }
}

.bubble {
  display: inline-block;
  margin: 20px 0 0;
  max-width: 75%;
  min-width: 20%;
  box-sizing: border-box;
}

.left {
  text-align: left;
  transform-origin: left;
}

.right {
  text-align: right;
  transform-origin: right;
}

.topic-row {
  border: 0;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  width: 100%; //min-width: 260px;
  display: block;
  transform: scale(0.8);

  &.scrollTransition {
    transition: 0.5s all;
  }

  &.onScreen {
    transform: scale(1);
  }
}

.host-head {
  display: inline-block;
  vertical-align: bottom;
  width: 9%;
  min-width: 48px;
  height: auto;
  box-sizing: border-box;
}

img {
  width: 100%;
  object-fit: contain;
  box-sizing: border-box;
  display: block;
  padding: 0 2px;

  &.left-henry {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  &.henry {
    &:after {
      content: "Small wonder";
    }
  }
}

</style>
